import {testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {useVehiclesActionCallback} from '../../hooks/useVehiclesActionCallback';
import {vehicleBulkOperationActionCallback} from '../../utils/vehicleBulkOperationActionCallback';

export function OSSaleVehicles() {
  const [actionCallback] = useVehiclesActionCallback();

  return (
    <DmsDataGrid
      gridCode="sale-vehicle-os"
      data-testid={testIds.vehicles.saleVehicleOpenSearch()}
      // eslint-disable-next-line eslint-js/no-restricted-syntax
      key="sale-vehicle-opensearch"
      actionCallback={actionCallback}
      bulkOperationActionCallback={vehicleBulkOperationActionCallback}
    />
  );
}
